import React from 'react';
import RadioField from 'customField/RadioField';
import { Field, FastField } from 'formik';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.label
 * @param {string | number | boolean} props.valueRadio
 * @param {"left" | "right"} props.positionLabel
 * @param {(event) => void} props.afterOnChange
 * @param {boolean} props.disabled
 * @returns
 */
const Radio = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={RadioField} {...props} />;
};

export default Radio;
